import kolkata from "public/dataCenters/kolkata.jpg";
import mumbai from "public/dataCenters/mumbai.jpg";
import lucknow from "public/dataCenters/lucknow.jpg";

export const DATA_CENTER_CONSTANTS = {
  ACTIVE_SERVICE_LOCATION: "Active Service Locations",
  DATA_CENTER: "Our Data Centers",
  DATA_CENTER_DESC: "We have a range of high-performance data centers.",
  DATA_CENTER_LOCATIONS: "Our Datacenter Locations",
  PlANNED_SERVICE_LOCATIONS: "Planned Service Locations",
};

export const PLANNED_SERVICE_LOCATIONS = [
  { id: 1, name: "Lucknow", image: lucknow },
  { id: 2, name: "Mumbai", image: mumbai },
  { id: 3, name: "Kolkata", image: kolkata },
];

export const DATA_CENTER_LOCATION_LIST = [
  {
    name: "New Delhi , India",
    address: "First+Floor+It-02,+CP-05,+Sector+8,+Imt+Manesar,+Gurugram,+Haryana+122051",
  },
  {
    name: "Bangalore, India | Gateway to APAC ",
    address:
      "Plot+111+%26+112,+Export+Promotion+Industrial+Park+5,+Bharti+Airtel+Limited,+Rd+Number+7,+Vijayanagar,+EPIP+Zone,+Whitefield,+Bengaluru,+Karnataka+560066",
  },
];
